import React from 'react';
import ReactDOM from 'react-dom';
import FilterTimeRange from './FilterTimeRange';
import '@jotforminc/jotform.css';

export default function init({ container, ...props }) {
  if (!container) return;

  ReactDOM.render(
    <FilterTimeRange
      {...props}
    />,
    container
  );
}

window.showFilterTimeRange = init;
